/** Stock create/update field help copy (info tooltips). */
export const STOCK_FIELD_HELP = {
  category: "Main grouping (e.g., Medicine, Lab Supplies).",
  subCategory: "Specific product type.",
  hsnSacCode: "Tax/HSN classification code.",
  name: "Scientific name or search keywords (generic name).",
  tradeName:
    "Brand name of the item along with product specifications (e.g., Nirlife Metronidazole Inj 100ml).",
  shortName:
    "Abbreviated display name. Shown in prescription & billing. If empty, falls back to trade name.",
  ingredient: "Main chemical component (active ingredient).",
  brand: "Manufacturer, brand, or marketer label.",
  nature: "Formulation (e.g., injection, ointment).",
  code: "Product barcode/SKU.",
  purchaseUom:
    "Unit in which it is normally purchased or preferred storage unit (e.g., Pcs, Box(es)).",
  adminUom: "Usage unit when administering (e.g., ml/mg).",
  dosage:
    "Strength or dosage amount. Indicative reference used while administering.",
  dosageType:
    "Dosage is approximated based on type: Fixed / Weight-Based / BSA (Body Surface Area).",
  reorderLevel: "Stock level that triggers a reorder.",
  reorderQty: "Suggested quantity to reorder when threshold is reached.",
  thresholdUom: "Unit used for the reorder threshold quantity.",
  drugSchedule: "Regulatory drug schedule.",
  description: "Brief product details.",
  cgst: "Central GST percentage.",
  sgst: "State GST percentage.",
  ndps: 'Mark "Y" if it\'s a NDPS Drug.',
  autoConsumed:
    'Mark "Y" if inventory is not tracked based on actual consumption. It is deducted as a whole unit at the time of stock transfer/adjustment.',
  billable: 'Mark "Y" if billable to client.',
  uomMapping: "Used when a product is sold in different UOMs.",
  conversionFactor:
    "Conversion factor from Purchase UOM to Sales UOM layer. E.g.: Purchase UOM = box(es). UOM layer 1 = strip(s), CF layer 1: 1 Box = 2 strip(s). UOM layer 2 = tablet(s), CF layer 2: 1 Box = 30 tablet(s).",
  salesUom: "Selling unit. Add multiple layers as necessary.",
  allowedSale:
    'Mark "Yes" if the given UOM is billable in current branch. Default is set to "Yes".',
  batchNumber: "Unique ID or code stamped on a specific product.",
  manufacturingDate: "The day the item was made or packaged.",
  expiryDate: "The deadline after which the product shouldn't be sold or used.",
  location: "The specific shelf, aisle, or room where the item is kept.",
  quantity: "The exact physical count or amount of the item in stock.",
  quantityUOM:
    "How the stock is counted (e.g., Bottle(s), Box(es), Pack(s)). Values will show based on what's added in UOM Mapping.",
  unitSellingPrice: "The price a customer pays for a single unit.",
  pricingUOM:
    "The unit used to set the price (e.g., charging per Box vs. per Piece).",
  landedCost:
    "Total cost to buy and deliver the item, including shipping and taxes. Auto-computed from purchases.",
  groupName: "Optional grouping label for organizing related products.",
  skuId: "Internal stock keeping unit identifier.",
};
